//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import cjimg from '@/assets/jianianhua/scratchcover.png'
import { getUserItem, award } from '@/api/lottery'
import { stampPay, stampGet, homePage } from '@/api/jianianhua'
import { relation, addCreditParty, view } from '@/api/jfhl.js'
export default {
  name: 'scratch',
  props: {},
  data () {
    return {
      ischeck: false,
      show: false,
      context: '',
      msg: '',
      lottery: true,
      lotid: '',
      partyid: '1391',
      zjlist: '',
      animate: false,
      stampnum: ''
    }
  },
  created () { },
  mounted () {
    this.getview()
    this.init()
    this.getstampnum()
  },
  computed: {
    accountid () {
      return this.$store.state.user.accountid
    },
    userid () {
      return this.$store.state.user.userid
    }
  },
  methods: {
    gorule () {
      this.$router.push({ name: 'jianianhuarule' })
    },
    getview () {
      view({
        id: this.partyid
      }).then(res => {
        this.lotid = res.obj.lotid
        this.getWinning()
      })
    },
    linkaddress () {
      this.$router.push({ name: 'jianianhuaAddress' })
    },
    getWinning () {
      getUserItem({
        openid: '',
        lotid: this.lotid,
        page: 1,
        rows: 10
      }).then(res => {
        this.zjlist = res.obj.items
        if (this.zjlist.length > 1) {
          setTimeout(this.lunbo, 2000)
        }
      })
    },
    lunbo () {
      var area = document.getElementById('record_wrap')
      var con1 = document.getElementById('con1')
      var con2 = document.getElementById('con2')
      con2.innerHTML = con1.innerHTML
      function scrollUp () {
        if (area.scrollTop >= con1.offsetHeight) {
          area.scrollTop = 0
        } else {
          area.scrollTop++
        }
      }
      var time = 20
      var mytimer = setInterval(scrollUp, time)
      area.οnmοuseοver = function () {
        clearInterval(mytimer)
      }
      area.οnmοuseοut = function () {
        mytimer = setInterval(scrollUp, time)
      }
    },
    // scroll () {
    //   let con1 = this.$refs.con1
    //   con1.style.marginTop = '-60px'
    //   this.animate = !this.animate
    //   var that = this // 在异步函数中会出现this的偏移问题，此处一定要先保存好this的指向
    //   setTimeout(function () {
    //     that.zjlist.push(that.zjlist[0])
    //     that.zjlist.shift()
    //     con1.style.marginTop = '0px'
    //     that.animate = !that.animate // 这个地方如果不把animate 取反会出现消息回滚的现象，此时把ul 元素的过渡属性取消掉就可以完美实现无缝滚动的效果了
    //   }, 1500)
    // },
    getstampnum () {
    },
    exchange () {
      this.lottery = false
      homePage({
        accountId: this.accountid
      }).then(data => {
        this.stampnum = data.obj.num
        if (this.stampnum < 200) {
          this.$vux.toast.text('邮票数不足')
        } else {
          this.getlottery()
        }
      })
    },
    // 抽中积分添加
    addJiFen (credit) {
      addCreditParty({
        accoutid: this.accountid,
        credit: credit,
        partyid: this.partyid,
        type: 1
      }).then(res => {
        if (res.success) {
          this.getWinning()
        }
      })
    },
    getlottery () {
      award({
        openid: this.accountid,
        lotid: this.lotid
      }).then(data => {
        if (data.obj.isaward === 1) {
          this.isaward = data.obj.isaward
          this.msg = data.obj.item
          if (data.obj.item.indexOf('积分') != -1) {
            this.addJiFen(data.obj.item.replace(/[^0-9]/ig, ''))
          }
          stampPay({
            accountId: this.accountid,
            num: 200,
            type: 5,
            ruleCode: 'GGL002'
          }).then(res => {
          })
        } else {
          this.$vux.alert.show({
            content: '您已经抽过奖',
            onHide () {
              location.reload()
            }
          })
        }
      })
    },
    init () {
      let canvas = document.getElementById('mask')
      // let context = canvas.getContext('2d')
      let _this = this
      var img = new Image()
      img.src = cjimg
      img.onload = function () {
        let context = canvas.getContext('2d')
        context.drawImage(img, 0, 0, 265, 97)
        context.globalCompositeOperation = 'destination-out'
        _this.context = context
      }
      // 鼠标按下 增加mousemove的事件监听
      canvas.addEventListener('touchstart', this.drawArcMouseHandle)
      canvas.addEventListener('touchsend', event => {
        // 鼠标抬起之后，把mousemove的事件监听撤销掉
        this.removeEventListener('touchmove', this.mousemoveHandle)
      })
      // 监听 touchmove
      canvas.addEventListener('touchmove', this.drawArcTouchHandle)
      this.show = true
    },
    // 根据鼠标的move画圆
    drawArcMouseHandle (event) {
      event.preventDefault()
      event.target.addEventListener('touchmove', this.mousemoveHandle)
    },
    // 为了能够移除movesemove的事件需要单独处理一下
    mousemoveHandle (event) {
      event.preventDefault()
      this.drawArcByPoint(event.pageX, event.pageY)
    },
    // 根据触摸点画圆
    drawArcTouchHandle (event) {
      if (this.ischeck) {
        event.preventDefault()
        var touch = event.touches[0]
        this.drawArcByPoint(touch.pageX, touch.pageY)
      } else {
        this.$vux.alert.show({ content: '请点击勾选上方栏位，确认相关规则后再参与活动' })
      }
    },
    // 根据某个点在canvas上画圆
    // x 坐标和 y 坐标 两个坐标是触摸点的坐标而不是画圆的圆心
    // 圆心通过计算得出
    drawArcByPoint (x, y) {
      this.context.beginPath()
      this.context.arc(
        x - canvas.offsetLeft,
        y - canvas.offsetTop,
        15,
        0,
        Math.PI * 2
      )
      this.context.closePath()
      this.context.fillStyle = '#ffffff'
      this.context.fill()
      this.checkComplete()
    },
    // 判断是否完成刮奖 点数大于80%
    checkComplete () {
      var imgData = this.context.getImageData(0, 0, 265, 97)
      var pxData = imgData.data // 获取字节数据
      var len = pxData.length // 获取字节长度
      var count = 0 // 记录透明点的个数
      // 主要的思想是 一个像素由四个数据组成，每个数据分别是 rgba() 所以第四个数据 a 表示alpha透明度
      for (var i = 0; i < len; i += 4) {
        var alpha = pxData[i + 3] // 获取每个像素的透明度
        if (alpha < 10) {
          // 透明度小于10
          count++
        }
      }
      var percent = count / (len / 4) // 计算百分比
      // 如果百分比大于0.8 则表示成功
      if (percent > 0.5) {
        if (this.lottery) {
          this.exchange()
        }
      }
      if (percent >= 0.6) {
        this.showResult()
      }
    },
    // 显示刮奖结果
    showResult () {
      this.context.clearRect(0, 0, 265, 97)
      if (this.isaward === 1) {
        this.zhongjiang = true
      }
    }
  }
}
